<template>
  <sc-select
    v-model="status"
    @input="newStatus"
    expanded>
    <option
      :value="null">{{ optionAll ? 'Todos' : 'Selecione' }}</option>
    <option
      v-for="(item, key) in listStatus"
      :value="key"
      :key="key">
      {{ item.text }}
    </option>
  </sc-select>
</template>

<script>
  import { ScSelect } from '@intelipost-js/secure-components';
  import EnumInvoiceAuditStatus from '../../enums/EnumInvoiceAuditStatus';

  export default {
    name: 'sc-invoice-audit-dropdown-status',
    props: {
      value: {
        type: String,
      },
      optionAll: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        status: this.value,
      };
    },
    computed: {
      listStatus() {
        return EnumInvoiceAuditStatus;
      },
    },
    methods: {
      newStatus(event) {
        this.$emit('input', event);
      },
    },
    components: {
      ScSelect,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/invoice-audit/components/sc-invoice-audit-dropdown-status/ScInvoiceAuditDropdownStatus.vue